import { useGetContactsForParticipantContactsParticipantGet } from "@/api-v3";
import StorageManager from "@/features/storage";

export const useSupportContacts = () => {
  const isAuthenticated = !!StorageManager.getTokenData()?.access_token;

  const query = useGetContactsForParticipantContactsParticipantGet({
    query: {
      enabled: isAuthenticated,
      staleTime: Infinity,
      gcTime: Infinity,
    },
  });

  const contacts = query.data?.data;

  return {
    contacts,
    hasContacts: (contacts?.length ?? 0) > 0,
    isLoading: query.isLoading,
    isError: query.isError,
    isFetched: query.isFetched,
  };
};
